<template>
  <div class="modal_wrap on">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">필터</h1>
        </div>
        <div class="modal_con">
          <div class="form_wrap">
            <div class="check_table" data-columns="2">
              <!--'2열: data-columns="2"', '3열: data-columns="3"'-->
              <label
                ><input
                  type="radio"
                  name="sort"
                  v-model="sort"
                  checked
                  :value="{ name: '퍼스 추천 순', value: 'RECOMMAND' }"
                /><span>퍼스 추천 순</span></label
              >
              <label
                ><input
                  type="radio"
                  name="sort"
                  v-model="sort"
                  :value="{ name: '신규 출시일 순', value: 'RELEASE_DT_DESC' }"
                /><span>신규 출시일 순</span></label
              >
              <label v-show="!isTelecomAll"
                ><input
                  type="radio"
                  name="sort"
                  v-model="sort"
                  :value="{
                    name: '출고가 높은 순',
                    value: 'FACTORY_PRICE_DESC',
                  }"
                /><span>출고가 높은 순</span></label
              >
              <label v-show="!isTelecomAll"
                ><input
                  type="radio"
                  name="sort"
                  v-model="sort"
                  :value="{
                    name: '출고가 낮은 순',
                    value: 'FACTORY_PRICE_ASC',
                  }"
                /><span>출고가 낮은 순</span></label
              >
              <label v-show="!isTelecomAll"
                ><input
                  type="radio"
                  name="sort"
                  v-model="sort"
                  :value="{
                    name: '공시지원 높은 순',
                    value: 'SUPPORT_MONEY_DESC',
                  }"
                /><span>공시지원 높은 순</span></label
              >
              <label v-show="!isTelecomAll"
                ><input
                  type="radio"
                  name="sort"
                  v-model="sort"
                  :value="{
                    name: '공시지원 낮은 순',
                    value: 'SUPPORT_MONEY_ASC',
                  }"
                /><span>공시지원 낮은 순</span></label
              >
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn" v-on:click="$emit('close')">확인</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceListSortModal',
  props: {
    isTelecomAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sort: { name: '퍼스 추천 순', value: 'RECOMMAND' },
    };
  },
};
</script>
